<div class="dialog">
  <header class="dialog__header">
    @if (isMobileView()) {
      <h3 class="dialog__header__title">Recurrence Dates</h3>
    }

    @if (isMobileView()) {
      <div class="dialog__header__action-buttons">
        <app-icon [ngStyle]="{ cursor: 'pointer' }" (click)="close()" iconName="close"></app-icon>
      </div>
    }
  </header>
</div>
<div class="dialog__content">
  <div class="date-form-wrapper">
    <form [formGroup]="form">
      <div class="input-group">
        <label for="recurrence" translate>Recurrence</label>
        <app-dropdown [options]="recurrenceOptions" bindValue="value" displayName="key" formControlName="recurrence" id="recurrence" name="recurrence"></app-dropdown>
        <app-form-error [control]="form.get('recurrence')" [name]="'Recurrence' | translate"></app-form-error>
      </div>

      <div class="input-group">
        <div class="flex-row-start-center gap-14">
          <label translate>Every</label>
          <input appNumberInput class="input-number-width" formControlName="repeatEvery" type="number" />
          <label> {{ RecurrenceSchedule[form.get('recurrence').value] | translate }}</label>
        </div>
        <app-form-error [control]="form.get('repeatEvery')" [name]="'Schedule' | translate"></app-form-error>
      </div>

      @if (this.form.get('recurrence').value === RecurrenceOption.RepeatWeekly) {
        <div class="input-group">
          <label for="week-days" translate>Week Days</label>
          <ng-select
            [closeOnSelect]="true"
            [items]="daysOfWeek"
            [multiple]="true"
            [placeholder]="'Select Options' | translate"
            [searchable]="true"
            bindLabel="name"
            bindValue="number"
            class="custom"
            id="week-days"
            name="week-days"
            formControlName="weekDays"
          ></ng-select>
          <app-form-error [control]="form.get('weekDays')" [name]="'Week Days' | translate"></app-form-error>
        </div>
      }

      <!--  Buttons  -->
      <div class="dialog__footer mt-24">
        @if (!isMobileView()) {
          <div class="dialog__footer__buttons">
            <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
            <app-button (click)="save()" [idleText]="'Save' | translate"></app-button>
          </div>
        }
      </div>
      @if (isMobileView()) {
        <div class="mobile-button">
          <app-button (click)="save()" [idleText]="'Save' | translate" cssClass="button-primary button-full mb-"></app-button>
        </div>
      }
    </form>
  </div>
</div>
